import clsx from 'clsx';

import ForecastInfoItem, { InfoItemStyles } from '@/components/ForecastInfoItem';
import GMField, { GMFieldStyles } from '@/components/GMField';
import { CurrentForecast } from '@/models/CurrentForecast';
import Barometer from '@/public/assets/forecast-info-icons/barometer.svg';
import Humidity from '@/public/assets/forecast-info-icons/humidity.svg';
import Precipitation from '@/public/assets/forecast-info-icons/precipitation.svg';
import Twater from '@/public/assets/forecast-info-icons/twater.svg';
import WindArrow from '@/public/assets/forecast-info-icons/wind-arrow.svg';
import Wind from '@/public/assets/forecast-info-icons/wind.svg';

type AdditionalInfoGridProps = Pick<
  CurrentForecast,
  | 'precipitation'
  | 'relativeHumidity'
  | 'magneticField'
  | 'pressure'
  | 'windDegrees'
  | 'windSpeed'
  | 'windDirection'
  | 'waterTemperature'
  | 'isWindSpeedAbnormal'
  | 'isPrecipitationAbnormal'
>;

const AdditionalInfoGrid = ({
  precipitation,
  relativeHumidity,
  magneticField,
  pressure,
  windDegrees,
  windSpeed,
  windDirection,
  waterTemperature,
  isWindSpeedAbnormal,
  isPrecipitationAbnormal,
}: AdditionalInfoGridProps) => (
  <div className="mt-4 flex flex-wrap pl-7 lg:mt-3.5 lg:pl-1 xl:pl-3">
    <div className="lg:flex">
      <ForecastInfoItem
        icon={<Precipitation className="h-[18px] w-[22px] lg:h-[24px] lg:w-[29px]" />}
        styleType={InfoItemStyles.MAIN}
        className="mb-2.5 lg:mb-0 lg:mr-10"
      >
        <span>
          <span className={clsx(isPrecipitationAbnormal && 'text-red')}>{precipitation.toFixed(1)}</span>&nbsp;мм
        </span>
      </ForecastInfoItem>

      <ForecastInfoItem
        icon={<Humidity className="h-[18px] w-[18px] lg:h-[24px] lg:w-[24px]" />}
        styleType={InfoItemStyles.MAIN}
        className="mb-2.5 lg:mb-0 lg:mr-10"
      >
        <span>{relativeHumidity}&nbsp;%</span>
      </ForecastInfoItem>

      <GMField gmData={magneticField} styleType={GMFieldStyles.MAIN} className="lg:hidden" />
    </div>
    <div className="ml-5 md:ml-10 lg:ml-0 lg:flex">
      <ForecastInfoItem
        icon={<Barometer className="h-[18px] w-[18px] lg:h-[24px] lg:w-[24px]" />}
        styleType={InfoItemStyles.MAIN}
        className="mb-2.5 lg:mb-0 lg:mr-10"
      >
        <span>{pressure}&nbsp;мм. рт. ст.</span>
      </ForecastInfoItem>
      <ForecastInfoItem
        icon={<Wind className="h-[18px] w-[22px] lg:h-[24px] lg:w-[29px]" />}
        styleType={InfoItemStyles.MAIN}
        subIcon={<WindArrow style={{ transform: `rotate(${windDegrees}deg)` }} className="ml-1 w-[9px] lg:w-[11px]" />}
        className="mb-2.5 lg:mb-0 lg:mr-10"
      >
        <span>
          <span className={clsx(isWindSpeedAbnormal && 'text-red')}>{windSpeed}</span>
          &nbsp;м/с,&nbsp;{windDirection}&nbsp;
        </span>
      </ForecastInfoItem>

      {waterTemperature !== undefined && (
        <ForecastInfoItem
          icon={<Twater className="h-[10px] w-[23px]" />}
          styleType={InfoItemStyles.MAIN}
          className="lg:hidden"
        >
          <span>{waterTemperature}&deg;</span>
        </ForecastInfoItem>
      )}
    </div>
    <div className="mt-4 hidden lg:flex xl:mt-0">
      <GMField gmData={magneticField} styleType={GMFieldStyles.MAIN} className="mr-10" />

      {waterTemperature !== undefined && (
        <ForecastInfoItem icon={<Twater className="h-[13px] w-[29px]" />} styleType={InfoItemStyles.MAIN}>
          <span>{waterTemperature}&deg;</span>
        </ForecastInfoItem>
      )}
    </div>
  </div>
);

export default AdditionalInfoGrid;
